/* Article resource card — mobile sticky capsule + bottom sheet.
   Desktop needs no JS: the card is static and the version picker is a <details>.

   The capsule/sheet are gated on matchMedia (not only CSS media queries) so the
   Shopify theme-editor preview — which renders a phone frame at desktop viewport
   width — still behaves correctly, and so they never leak onto real desktop. */
(() => {
  const firstLoad = !window.ebArticleResourceLoaded;
  window.ebArticleResourceLoaded = true;

  const REVEAL_DEPTH = 0.35;
  const mq = window.matchMedia('(max-width: 768px)');

  const init = (scope = document) => {
    const roots = [];
    if (scope.matches?.('[data-eb-resource]')) roots.push(scope);
    roots.push(...(scope.querySelectorAll?.('[data-eb-resource]') || []));

    roots.forEach((root) => {
      if (root.dataset.ebResourceReady === 'true') return;

      const bar = root.querySelector('[data-eb-resource-bar]');
      const sheet = root.querySelector('[data-eb-resource-sheet]');
      const mobileMode = root.dataset.mobile === 'sheet';
      if (!bar || !sheet || !mobileMode) return;
      root.dataset.ebResourceReady = 'true';

      const anchor = document.querySelector('[data-article-content]');
      let raf = 0;

      const depth = () => {
        if (anchor) {
          const box = anchor.getBoundingClientRect();
          const total = box.height - window.innerHeight;
          if (total <= 0) return box.bottom < window.innerHeight ? 1 : 0;
          return Math.min(Math.max(-box.top / total, 0), 1);
        }
        const total = document.documentElement.scrollHeight - window.innerHeight;
        return total > 0 ? window.scrollY / total : 0;
      };

      const sync = () => {
        raf = 0;
        if (!mq.matches) {
          bar.dataset.shown = 'false';
          return;
        }
        const isOpen = sheet.open === true || sheet.hasAttribute('open');
        bar.dataset.shown = String(!isOpen && depth() > REVEAL_DEPTH);
      };

      const onScroll = () => {
        if (raf) return;
        raf = requestAnimationFrame(sync);
      };

      const open = () => {
        bar.dataset.shown = 'false';
        if (typeof sheet.showModal === 'function') {
          try {
            sheet.showModal();
          } catch (e) {
            sheet.setAttribute('open', '');
          }
        } else {
          sheet.setAttribute('open', '');
        }
      };

      function close() {
        if (typeof sheet.close === 'function' && sheet.open) {
          sheet.close();
        } else {
          sheet.removeAttribute('open');
        }
        sync();
      }

      const applyMode = () => {
        root.dataset.mobileActive = mq.matches ? 'true' : 'false';
        if (!mq.matches) {
          bar.dataset.shown = 'false';
          if (sheet.open || sheet.hasAttribute('open')) close();
        } else {
          sync();
        }
      };

      bar.addEventListener('click', open);

      root.querySelectorAll('[data-eb-resource-close]').forEach((btn) => {
        btn.addEventListener('click', close);
      });

      /* Tapping the backdrop area outside the panel closes the sheet. */
      sheet.addEventListener('click', (event) => {
        if (!event.target.closest('.eb-res-sheet__panel')) close();
      });

      sheet.addEventListener('close', sync);
      sheet.addEventListener('cancel', () => window.setTimeout(sync, 0));

      /* Following the download or tool link dismisses the sheet. */
      sheet.querySelectorAll('a[href]').forEach((link) => {
        link.addEventListener('click', () => window.setTimeout(close, 120));
      });

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => { applyMode(); onScroll(); }, { passive: true });

      if (mq.addEventListener) mq.addEventListener('change', applyMode);
      else if (mq.addListener) mq.addListener(applyMode);

      applyMode();
    });
  };

  init(document);

  if (firstLoad) {
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }
})();
